<template>
<div style=" height: 100%; margin-top:10px">
    <v-card class="  mt-15 pa-7">
        <v-card-title>
            Agent Information
        </v-card-title>
        <v-divider style="margin:0"></v-divider>
        <h2 class="title-txt"></h2>
        <div >
            <div class="total_user tu1">
                <div class="user">
                    <div>
                        <img class="p-img" :src="agent.passport" alt="">
                    </div>
                    <div class="mt-5">
                    
                        <h5>Full Name: {{agent.surName}} {{agent.firstName}} </h5>
                        <h5>Email: {{agent.emailAdd}}</h5>
                        <h5>Date Of Birth: {{agent.dateofBirth}}</h5>
                        <h5>Business Name: {{agent.businessName}}</h5>
                        <h5>Address: {{agent.businessAddress}}</h5>
                        <h5>City: {{agent.city}}</h5>
                        <h5>State: {{agent.state}}</h5>
                    </div>
                </div>
            </div>
        </div>
    </v-card>    

    <div class="col-md-12" style="margin-top:50px">
         

         <v-tabs v-model="tab">
            <v-tab>More Agent Info</v-tab>
            <v-tab>Transactions</v-tab>    
          </v-tabs>
          <v-tabs-items v-model="tab" style="margin-top:30px; background-color: transparent; padding:3px 0 3px 0">
            <v-tab-item style="padding:0;">

                </v-tab-item>
            
      <v-tab-item style="padding:0;">


        <v-card>
            <div class="col-md-4 mb-5" style="margin-top:10px !important">
                Total Agent Transaction : 3434343434
            </div>

                        <v-data-table :headers="headers" :items="desserts" :search="search" class="pa-0 elevation-2" :items-per-page="20">
                            <template v-slot:[`item.sn`]="{ item }" >
                                <tr>
                                    <td class="table-txt">{{desserts.map(function(x) {return x.transactionRef; }).indexOf(item.transactionRef)+1}}</td>
                                </tr>
                            </template>
                            
                            <template v-slot:[`item.roles`]="{ item }">
                                <span class="" v-for="(role,index) in item.roles" :key="index">{{ role.name }},</span>
                            </template>
                            <template v-slot:[`item.user_since`]="{ item }">
                                <td class="table-txt">{{ item.user_since }}</td>
                            </template>
                            <template v-slot:[`item.actions`]="{ item }">
                                <v-menu transition="slide-x-transition" bottom right>
                                    <template v-slot:activator="{ on: menu, attrs }">
                                        <v-btn style="background: #e5e5e5; padding: 4px 10px" small text class="ml-3 my-2" v-bind="attrs" v-on="{ ...menu }">
                                            <span style="color: grey; font-size: 20px">
                                                <i class="fas fa-ellipsis-h"></i>
                                            </span>
                                        </v-btn>
                                    </template>
                                    <v-card style="display: flex; flex-direction: column; text-align: center; padding: 10px 0">
                                        <v-btn text color="secondary" @click="editUser(item)">
                                            <h6 style="font-size: 14px">
                                                Edit User
                                            </h6>
                                        </v-btn>
                                        <!-- <v-btn text color="secondary" @click="editItem(item)">
                           <h6 style="font-size: 14px">
                               Edit Permission
                           </h6>
                       </v-btn> -->
                                        <v-btn text color="secondary" @click="deletUser(item,1)">
                                            <h6 style="font-size: 14px">
                                                Delete User
                                            </h6>
                                        </v-btn>
                                        <!-- <v-btn text color="secondary" @click="deletUser(item,2)">
                           <h6 style="font-size: 14px">
                               Block User
                           </h6>
                       </v-btn> -->
                                    </v-card>
                                    <!-- <v-list>
                       <v-list-item v-for="(item, i) in items" :key="i">
                           <v-list-item-title>{{ item.title }}</v-list-item-title>
                       </v-list-item
                   </v-list> -->
                                </v-menu>
                            </template>
                            <template v-slot:[`item.status`]="{item}">
                                <td class="table-txt">{{ item.status }}</td>
                            </template>
                            
                        </v-data-table>
                    </v-card>
        </v-tab-item>
          </v-tabs-items>
          </div>

  </div>
</template>

<script>
import axios from "axios";
export default {
data(){
    return {
        tab:'',
        search:'',
            headers: [{
                    text: 'S/N',
                    align: 'start',
                    value: 'sn',
                    class: 'grey lighten-4 text-center title',
                },
                {
                    text: 'Agent ID',
                    value:'agentID',
                    class: 'grey lighten-4 text-center title',
                },
                {
                    text: 'Terminal ID',
                    value: 'terminalID',
                    class: 'grey lighten-4 text-center title',
                },
                {
                    text: 'Transaction Date',
                    value: 'transactionDate',
                    class: 'grey lighten-4 text-center title',
                },
                {
                    text: 'Amount',
                    value: 'amount',
                    class: 'grey lighten-4 text-center title',
                },
                {
                    text: 'Fee',
                    value: 'fee',
                    class: 'grey lighten-4 text-center title',
                },
                {
                    text: 'Transaction ID',
                    value: 'transactionRef',
                    class: 'grey lighten-4 text-center title',
                },
                {
                    text: 'Type',
                    value: 'transactionType',
                    class: 'grey lighten-4 text-center title',

                },
                {
                    text: 'Status',
                    value: 'transactionStatus',
                    class: 'grey lighten-4 text-center title',

                },
                {
                    text: 'Card Type',
                    value: 'cardType',
                    class: 'grey lighten-4 text-center title',

                },
                {
                    text: 'Bank',
                    value: 'bank',
                    class: 'grey lighten-4 text-center title',

                }
            ],
            desserts: [],
            analytics: {},
            agent: {}

        }

},
mounted(){
    this.getTransDetails(this.$router.currentRoute.params.id)
    // this.desserts = JSON.parse(data)
},


methods:{

    getTransDetails(x) {
       const data = {
        agentId: x
        }
const url = process.env.VUE_APP_UB_V1_API_ENDPOINT+`fetch-agent-transactions`
axios.post(
    url,
    data
).then((response) => {
    if (response.data.code == 's200') {
        // this.analytics = response.data.message.analytics;
        this.desserts =response.data.message.transactions;
        this.agent = response.data.message.agent;
        // response.data.message.transactions.forEach(el => {
        //     this.desserts.push({
        //         full_name: el.agentId,
        //         email: el.transactionDate.split('T')[0],
        //         roles: el.amount,
        //         created_at: el.transactionId,
        //         status: el.transactionStatus == 1 ? 'Successful' : el.transactionStatus == 2 ? 'Fail' : 'Pending',
        //         actions: el.bank
        //     })
        // })
        // this.$toast.open({
        //     message: response.data.message,
        //     type: 'success',
        //     position: 'top-right'
        // });
    }
}).catch(e => {
    this.$toast.open({
        message: e.response.data.message,
        type: 'error',
        position: 'top-right'
        // all of other options may go here
    });
})

}
}

}
</script>

<style>
.p-img{
    height: 150px;
    width: 150px;
    border-radius: 50%;
}
</style>